import { RestClient } from '../lib/RestClient'

class PasswordService extends RestClient {
  constructor() {
    super('password')
  }

  async find(link, params = {}) {
    const response = await this.request.get(`find/${link}`, {
      params
    })
    return response.data
  }

  async reset(body, params = {}) {
    const response = await this.request.post('reset', body, {
      params,
      noToast: true
    })
    return response
  }
  async enviar(email, params = {}) {
    const response = await this.request.post(
      'create',
      { email: email },
      {
        params
      }
    )
    return response.data
  }
}

export const Password = new PasswordService()
